import React from "react";
import "./Pagination.css";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

function Pagination({ pagination, onPageChange }) {
  if (!pagination || pagination.total_pages <= 1) {
    return null;
  }

  const { page, total_pages, count } = pagination;

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= total_pages) {
      onPageChange(newPage);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
    let endPage = Math.min(total_pages, startPage + maxVisible - 1);

    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    if (startPage > 1) {
      pages.push(1);
      if (startPage > 2) {
        pages.push("...");
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < total_pages) {
      if (endPage < total_pages - 1) {
        pages.push("...");
      }
      pages.push(total_pages);
    }

    return pages;
  };

  return (
    <div className="pagination-container">
      <div className="pagination-info">
        Showing page {page} of {total_pages} ({count} total items)
      </div>
      <div className="pagination-controls">
        <button
          className="pagination-btn pagination-prev"
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
          aria-label="Previous page"
        >
          <FiChevronLeft size={18} />
          Previous
        </button>

        <div className="pagination-numbers">
          {getPageNumbers().map((pageNum, idx) =>
            pageNum === "..." ? (
              <span key={`ellipsis-${idx}`} className="pagination-ellipsis">
                ...
              </span>
            ) : (
              <button
                key={pageNum}
                className={`pagination-number ${
                  pageNum === page ? "active" : ""
                }`}
                onClick={() => handlePageChange(pageNum)}
              >
                {pageNum}
              </button>
            ),
          )}
        </div>

        <button
          className="pagination-btn pagination-next"
          onClick={() => handlePageChange(page + 1)}
          disabled={page === total_pages}
          aria-label="Next page"
        >
          Next
          <FiChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
